import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import {
  AddressSearchParams,
  AssignedShipToPage,
  AvailableShipTosSearchParams,
  DeliveryAddressSearchResult,
} from '../../../core/model';
import { AvailableSoldTosSearchParams, SoldTo, SoldToSearchResult } from '../../../core/model/user.model';
import { Occ } from '../../../core/occ/occ-models';
import { ConverterService } from '../../../core/util';
import { SOLD_TO_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class SoldToConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  loadAvailable(searchParams: AvailableSoldTosSearchParams, userId: string) {
    const url = this.occEndpointsService.buildUrl('soldTos', {
      urlParams: { userId },
      queryParams: {
        fields: 'FULL',
        search: searchParams.text,
        userUid: searchParams.userUid,
        page: searchParams.page ?? 0,
        count: searchParams.count ?? 10,
        connectedToPermissionCode: searchParams.connectedToPermissionCode,
        permissionCode: searchParams.permissionCode,
        shoppingListCode: searchParams.shoppingListCode,
      },
    });
    return this.httpClient.get<SoldToSearchResult>(url);
  }

  loadActive(userId: string): Observable<SoldTo> {
    const url = this.occEndpointsService.buildUrl('soldTo', {
      urlParams: {
        userId,
        soldToId: 'current',
      },
      queryParams: {
        fields: 'FULL',
      },
    });
    return this.httpClient.get<Occ.SoldTo>(url).pipe(this.converterService.pipeable(SOLD_TO_NORMALIZER));
  }

  change(userId: string, uid: string): Observable<SoldTo> {
    const url = this.occEndpointsService.buildUrl('changeSoldTo', {
      urlParams: { userId },
      queryParams: { soldToId: uid },
    });
    return this.httpClient.put<Occ.SoldTo>(url, {}).pipe(this.converterService.pipeable(SOLD_TO_NORMALIZER));
  }

  loadDeliveryAddresses(searchParams: AddressSearchParams, userId: string): Observable<DeliveryAddressSearchResult> {
    const url = this.occEndpointsService.buildUrl('deliveryAddresses', {
      urlParams: { userId: userId },
      queryParams: {
        fields: 'FULL',
        search: searchParams.text,
        page: searchParams.page ?? 0,
        count: searchParams.count ?? 10,
        sort: 'name1:asc',
      },
    });
    return this.httpClient.get<DeliveryAddressSearchResult>(url);
  }

  loadAvailableShipTos(searchParams: AvailableShipTosSearchParams, userId: string): Observable<AssignedShipToPage> {
    const url = this.occEndpointsService.buildUrl('availableShipTosWithSoldTo', {
      urlParams: { userId: userId },
      queryParams: {
        fields: 'FULL',
        search: searchParams.text,
        userUid: searchParams.userUid,
        onlyConnected: searchParams.onlyConnected,
        soldTos: searchParams.soldTos,
        page: searchParams.page ?? 0,
        count: searchParams.count ?? 10,
        connectedToPermissionCode: searchParams.connectedToPermissionCode,
        permissionCode: searchParams.permissionCode,
      },
    });
    return this.httpClient.get<AssignedShipToPage>(url);
  }
}
